import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterLink} from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { GoogleTagService } from '@app/services/google-tag-manager.service';
import { MenuStateService } from '@app/services/menu-state.service';
import { PaymentService } from '@app/services/payment.service';
import { VersionService } from '@app/services/version.service';
import { TriggerReleaseNotesComponent } from '@app/components/release-notes/trigger-release-notes/trigger-release-notes.component';
import { UserIconComponent } from '@app/profile/user-icon/user-icon.component';
import { RedDotComponent } from '@app/version/red-dot.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-user-menu-mobile',
  imports: [RouterLink, CommonModule, UserIconComponent, TranslocoPipe, TriggerReleaseNotesComponent, Button, RedDotComponent],
  templateUrl: './user-menu-mobile.component.html',
  standalone: true,
})
export class UserMenuMobileComponent {
  menuStateService = inject(MenuStateService);
  paymentService = inject(PaymentService);
  // voiceService = inject(VoiceService);
  authService = inject(AuthService);
  googleTagService = inject(GoogleTagService);
  versionService = inject(VersionService);

  isAdmin = computed(() => this.authService.userIsAdmin());
  subscriptionExpired = computed(() => this.paymentService.subscriptionExpired());
  gtmIsEnabled = computed(() => this.googleTagService.gtmIsEnabled());
}
